/** @file The auto-rig panel session: analyse → review with a ghost → apply as one commit → undo. */
import { createStore } from 'zustand/vanilla';
import { applyReviewed } from './applyReviewed';
import type { AutorigPorts, AutorigSession, AutorigView, SessionCore } from './autorigTypes';
import { ghostOf } from './ghostOf';
import { runAnalysis } from './runAnalysis';
import { undoApplied } from './undoApplied';

/** One per open project; close() clears the panel's ghost and drops answers still in flight. */
export function createAutorigSession(ports: AutorigPorts): AutorigSession {
  const store = createStore<AutorigView>()(() => ({ kind: 'idle' }));
  const core: SessionCore = { store, ports, ticket: { n: 0 } };
  return {
    store,
    run: (request) => runAnalysis(core, request),
    apply: () => applyReviewed(core),
    undo: () => undoApplied(core),
    setGhost: (visible) => {
      const view = store.getState();
      if (view.kind !== 'review') return;
      const next = { ...view, ghost: visible };
      store.setState(next, true);
      ports.showGhost(ghostOf(next));
    },
    close: () => {
      core.ticket.n += 1;
      ports.showGhost(null);
      store.setState({ kind: 'idle' }, true);
    },
  };
}
